exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@import (reference) '~core/presentation/less/imports/commonImports.less';\n\n.HoverablePopover {\n  display: inline;\n  -webkit-text-decoration: dotted underline var(--color-dovegray);\n          text-decoration: dotted underline var(--color-dovegray);\n}\n", ""]);

